import axios from 'axios';

export type ToggleFavoriteResponse = {
  exists: boolean;
};

const toggle = async (listingId: string) => {
  const { data } = await axios.post<ToggleFavoriteResponse>(
    `/favorite/${listingId}`,
  );
  return data;
};

export default toggle;
